import React from "react";
import { Button } from "./ui/button";
import {
  MapPin,
  Phone,
  Mail,
  MessageCircle,
  ArrowRight,
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
} from "lucide-react";
import { mockData } from "../mock";
import Logo from "src/assets/Images/GJ SkillBay Labs (Logo Presentation)-01.svg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Brand & Contact */}
          <div className="space-y-6">
            <div>
              <div className="flex items-center mb-4">
                <img
                  src={Logo}
                  alt="GJ SkillBay Labs Logo"
                  className="h-10 w-auto brightness-0 invert"
                  onError={(e) => {
                    // Fallback to text logo if image fails to load
                    e.target.style.display = "none";
                    e.target.nextElementSibling.style.display = "flex";
                  }}
                />
                <div className="hidden w-10 h-10 bg-orange-500 rounded-lg items-center justify-center text-white font-bold text-lg">
                  GJ
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed">
                Committed to advancing the next generation of technical talent
                through immersive training and industry-led mentorship.
              </p>
            </div>

            {/* Quick Contact Actions */}
            <div className="space-y-3">
              <a
                href="https://api.whatsapp.com/send?phone=919895223307"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-green-600 hover:bg-green-700 text-white flex items-center justify-center gap-2 py-2 rounded-xl"
              >
                <MessageCircle size={18} />
                Consult via WhatsApp
              </a>
              <Button
                variant="outline"
                className="w-full border-gray-600 text-white hover:bg-gray-800 flex items-center justify-center gap-2"
                onClick={() =>
                  window.open(`tel:${mockData.contact.phone}`, "_self")
                }
              >
                <Phone size={18} />
                Contact Admissions Support
              </Button>
            </div>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Programs</h3>
            <ul className="space-y-3">
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("domains")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Python & AI Development
                </button>
              </li>
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("domains")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Mobile App Development
                </button>
              </li>
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("domains")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Java Enterprise Development
                </button>
              </li>
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("domains")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  UX/UI Design & Frontend
                </button>
              </li>
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("domains")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  QA & Test Automation
                </button>
              </li>
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("domains")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  DevOps Engineering
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("whyGj")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Why SkillBay
                </button>
              </li>
              <li>
                <button
                  className="text-gray-300 hover:text-white transition-colors text-left"
                  onClick={() =>
                    document
                      .getElementById("programs")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Program Structure
                </button>
              </li>
              <li>
                <a
                  href="#mentors"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Mentor Network
                </a>
              </li>
              <li>
                <a
                  href="#social-proof"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Success Stories
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Location */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Connect With Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin
                  className="text-blue-400 mt-1 flex-shrink-0"
                  size={20}
                />
                <div>
                  <p className="font-medium">Unit-30 & 31/B1, Sahya Building</p>
                  <p className="text-gray-300 text-sm">
                    Govt.Cyberpark, Kozhikode,Calicut, Kerala 673 016
                  </p>
                  <button
                    className="text-blue-400 hover:text-blue-300 text-sm flex items-center gap-1 mt-1"
                    onClick={() =>
                      window.open(
                        "https://maps.google.com/?q=Cyberpark+Kozhikode",
                        "_blank"
                      )
                    }
                  >
                    Get Directions <ArrowRight size={14} />
                  </button>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Phone className="text-blue-400 flex-shrink-0" size={20} />
                <div>
                  <p className="font-medium">Call Admissions</p>
                  <div className="flex gap-3">
                    <p className="text-gray-300 text-sm">
                      {mockData.contact.phone},
                    </p>
                    <p className="text-gray-300 text-sm">
                      {mockData.contact.phoneTwo}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Mail className="text-blue-400 flex-shrink-0" size={20} />
                <div>
                  <p className="font-medium">Email Us</p>
                  <p className="text-gray-300 text-sm">
                    {mockData.contact.email}
                  </p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="mt-6">
              <p className="font-medium mb-3">Follow Us</p>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/share/1HXE3hjUNk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
                >
                  <Facebook size={18} />
                </a>

                <a
                  href="https://www.instagram.com/gjskillbay/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors"
                >
                  <Instagram size={18} />
                </a>

                <a
                  href="https://www.linkedin.com/company/gj-skillbay-labs/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-blue-700 rounded-lg flex items-center justify-center transition-colors"
                >
                  <Linkedin size={18} />
                </a>

                <a
                  href="https://www.youtube.com/@GJGlobal-g26"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors"
                >
                  <Youtube size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} GJ SkillBay Labs. All rights reserved.
            </p>

            <div className="flex flex-wrap gap-6 text-sm">
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
              >
                Placement Terms
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-blue-600 text-white p-4 z-50 md:hidden">
        <div className="flex gap-2">
          <Button
            size="sm"
            className="flex-1 bg-white text-blue-600 hover:bg-blue-50"
            onClick={() =>
              document
                .getElementById("hero-form")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Get Syllabus & Fees
          </Button>
          <Button
            size="sm"
            variant="outline"
            className="border-white text-white hover:bg-white/10"
            onClick={() =>
              window.open(
                `https://wa.me/${mockData.contact.whatsapp}`,
                "_blank"
              )
            }
          >
            <MessageCircle size={16} />
          </Button>
        </div>
      </div>
    </footer>
  );
};
